import { withStyles } from '@material-ui/core/styles';
import * as React from 'react';

// import Button from '@material-ui/core/Button';
import {Button ,Card, Col,Label, Row } from 'reactstrap';

import { Icon} from 'react-materialize';

import Input from '@material-ui/core/Input';

import { Link } from 'react-router-dom';

// DropDownMenu
import DropDownMenu from '../../components/DropDownMenu/DropDownMenu.Component';

import Loader from 'react-loader'

import PropTypes from 'prop-types';

import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import Typography from '@material-ui/core/Typography';

import Select from '@material-ui/core/Select';

import MenuItem from '@material-ui/core/MenuItem';

// router
import { Redirect } from "react-router-dom";

// styling
import './CreateInteractionWizard.css';

// components
import NavBar from '../../components/CustomNav/CustomNav.Component';
import RecallInteraction from '../../components/RecallInteraction/RecallInteraction.Component';
import DragDropInteraction from '../../components/DnDInteraction/DragDropInteraction.Component';
import MultipleChoiceInteraction from '../../components/MultipleChoiceInteraction/MultipleChoiceInteraction.Component';
import MultipleChoiceMultiInteraction from '../../components/MultipleChoiceMultiInteraction/MultipleChoiceMultiInteraction.Component';
import TabView from '../../components/TabView/TabView.Component';

import {createItemJson, currentBaseUrl, getGeneralSmartTableData} from '../../common/services';

export interface IState {
  state: any;
  current: any;
  classes: any;
  completed?: any;
  optional?: any;
}

const value = 0;

let question = '';
question = 'The quick brown fox jumps over the lazy dog. The big bald eagle takes flight on one sunny Monday morning.';

const dragquestions = []  as any[];

const choiceanswers = []  as any[];

let newchoiceanswer = '';
newchoiceanswer='Choice X';

let newchoiceansweriscorrect = true;
newchoiceansweriscorrect=false;

let newdrag = '';
newdrag = 'What is Place Value?'

let newdrop = '';
newdrop = 'The numerical value a digit has depending on its position in a number'

let newdragcompletion = '';
newdragcompletion = 'You nailed it! Good job.'

let introtext = '';
introtext = 'In about 10 seconds, some tests are going to be displayed, look at them carefully and answer as best as you can. '

let completiontext = '';
completiontext = 'Congratulations on Completing!'

let buttontext = '';
buttontext = 'Submit'

let typecontent = '';
typecontent = 'The quick brown fox interaction'

let timelimit = 0;
timelimit = 120

let extratime = 0;
extratime = 1

let rangemin = 0;
rangemin = 10

let minperinteraction = 0;
minperinteraction = -850

let maxperinteraction = 0;
maxperinteraction = 850

let rangemax = 0;
rangemax = 30

let penalty = 0;
penalty = 2

let redwords = '';
redwords = 'fox,dog,eagle,flight'


let interactiontype = '1';
interactiontype = '1'

const styles = theme => ({
  button: {
    marginLeft: '3%',
    marginRight: theme.spacing.unit,
  },
  icons: {
    fontSize: 50
  },
  instructions: {
    marginBottom: theme.spacing.unit,
    marginLeft: '3%',
    marginTop: theme.spacing.unit,
  },
  root: {
    marginLeft: '-2%',
    width: '100%',
  },

});

function getSteps() {
  return ['Choose a one mode', 'Configure interaction', 'Preview Interaction', 'Save Interaction'];
}

function getStepContent(step, props) {
  switch (step) {
    case 0:
      return chooseMode(props);
    case 1:
      return addCopy(props);
    case 2:
      return previewInteraction(props);
    default:
      return saveInteraction(props);
  }
}

function interactionComplete () {
  console.log('complete');
}

function previewInteraction(props) {
  if (props.state.interactiontype === '1') {
    return(
      <div className="interaction-component-container">
        <p className="interaction-type-title">Recall Interaction</p>
        <RecallInteraction oncomplete={interactionComplete} demomode={true} show={true} lessonid="1" interactionid="1" completiontext={completiontext} submittext={buttontext} introtext={introtext} question={question} redwords={redwords} penalty={penalty} timelimit={timelimit}/>
      </div>
    );
  }
  else if (props.state.interactiontype === '2') {
    return(
      <div className="interaction-component-container">
        <p className="interaction-type-title">DnD Interaction</p>
        <DragDropInteraction oncomplete={interactionComplete} demomode={true} show={true} lessonid="1" interactionid="1" completiontext={completiontext} submittext={buttontext} introtext={introtext}  dragquestions={dragquestions} penalty={penalty} timelimit={timelimit}/>
      </div>
    );
  }
  else if (props.state.interactiontype === '3') {
    return(
      <div className="interaction-component-container">
        <p className="interaction-type-title">Multiple Choice Interaction</p>
        <MultipleChoiceInteraction oncomplete={interactionComplete} demomode={true} show={true} lessonid="1" interactionid="1" completiontext={completiontext} submittext={buttontext} introtext={introtext}  question={question} answers={choiceanswers} penalty={penalty} timelimit={timelimit}/>
      </div>
    );
  }
  else if (props.state.interactiontype === '4') {
    return(
      <div className="interaction-component-container">
        <p className="interaction-type-title">Multiple Choice Multi Interaction</p>
        <MultipleChoiceMultiInteraction oncomplete={interactionComplete} demomode={true} show={true} lessonid="1" interactionid="1" completiontext={completiontext} submittext={buttontext} introtext={introtext}  question={question} answers={choiceanswers} penalty={penalty} timelimit={timelimit}/>
      </div>
    );
  }
  else{
    return(
      <div>
        <p>No interaction</p>
      </div>
    );
  }
}

function chooseMode(props) {
  return (
    <div id="steps1">
      <Row>
        <div className='upload-interaction-card'>
            <h2 className="card-title">Upload Interaction from CSV File</h2>
            {/* <br/><br/> */}
            <form onSubmit={UploadSubmit}>
            <div id="attach_files">
              <Icon medium={true}>attach_file</Icon>
              <input id="upld" name="upld" type="file" accept=".csv" required={true}/>
            </div>
            <button className="blue-button submit-interaction" style={{marginTop: '5px'}}  type="submit">Submit</button>
          </form>

        </div>



          <div className='create-interaction-card'>
          <h2 className="card-title">Create Interactoin from Template</h2>
            <Icon medium={true}>assignment</Icon>
            <br/>

            <Select

              value={props.state.interactiontype}
              onChange={props.handleTypeChange}
              style={{color: 'white!important'}}
              >
              <MenuItem  value={'1'} >Recall Word</MenuItem>
              <MenuItem value={'2'}>Drag and Drop</MenuItem>
              <MenuItem value={'3'}>Multiple Choice</MenuItem>
              <MenuItem value={'4'}>Multiple Choice(Multi)</MenuItem>
            </Select>
          </div>
      </Row>
    </div>
  )
}

function handleChange(event, changeValue){
    return changeValue ++;
};

function handleTypeChange(event) {
  interactiontype = event.target.value;
  console.log(interactiontype);
}

function UploadSubmit(event){
  console.log('upload complete');
  const fileInputElement = event.target.elements.upld;
  const fls = fileInputElement.files[0];
}

function handleDragAdd(event) {
  dragquestions.push({drag: newdrag, drop: newdrop, completion: newdragcompletion});
}

function handleAnswerAdd(event) {
  choiceanswers.push({answer_text: newchoiceanswer, is_correct_answer: newchoiceansweriscorrect});
  newchoiceansweriscorrect = false;
}

function handleDragRemove(event) {
  // dragquestions.push({drag: newdrag, drop: newdrop});
  console.log('remove: ' + event);
}

function handleSelectionChange(e){
  newchoiceansweriscorrect = e.target.checked;
  console.log('newval: ' + newchoiceansweriscorrect);
}

function handleInputChange(event){
    const valnm = event.currentTarget.dataset.arg;
    console.log(event.target.value);
    console.log(valnm);
    if (valnm === 'introtext') {
      introtext = event.target.value;
      console.log('introtext changed');
    }
    else if (valnm === 'completiontext') {
      completiontext = event.target.value;
      console.log('completiontext changed');
    }
    else if (valnm === 'buttontext') {
      buttontext = event.target.value;
      console.log('buttontext changed');
    }
    else if (valnm === 'redwords') {
      redwords = event.target.value;
      console.log('redwords changed');
    }
    else if (valnm === 'question') {
      question = event.target.value;
      console.log('question changed');
    }
    else if (valnm === 'typecontent') {
      typecontent = event.target.value;
      console.log('typecontent changed');
    }
    else if (valnm === 'timelimit') {
      timelimit = event.target.value;
      console.log('timelimit changed');
    }
    else if (valnm === 'penalty') {
      penalty = event.target.value;
      console.log('penalty changed');
    }
    else if (valnm === 'extratime') {
      extratime = event.target.value;
      console.log('extratime changed');
    }
    else if (valnm === 'rangemin') {
      rangemin = event.target.value;
      console.log('rangemin changed');
    }
    else if (valnm === 'rangemax') {
      rangemax = event.target.value;
      console.log('rangemax changed');
    }
    else if (valnm === 'newdrag') {
      newdrag = event.target.value;
      console.log('newdrag changed');
    }
    else if (valnm === 'newdrop') {
      newdrop = event.target.value;
      console.log('newdrop changed');
    }
    else if (valnm === 'newdragcompletiontext') {
      newdragcompletion = event.target.value;
      console.log('newdragcompletion changed');
    }
    else if (valnm === 'newchoiceanswer') {
      newchoiceanswer = event.target.value;
      console.log('newchoiceanswer changed');
    }
    else if (valnm === 'minperinteraction') {
      minperinteraction = event.target.value;
      console.log('minperinteraction changed');
    }
    else if (valnm === 'maxperinteraction') {
      maxperinteraction = event.target.value;
      console.log('maxperinteraction changed');
    }

};

function addCopy(props) {
  return (
    <div id="steps">
      <Row>

        <TabView intro={introtext} inputchange={handleInputChange} newdrag={newdrag} newchoicecorrect={newchoiceansweriscorrect}
         interactiontype={props.state.interactiontype} question={question} newdrop={newdrop} newchoiceanswer={newchoiceanswer} selectionchange={handleSelectionChange}
         completiontext={completiontext} buttontext={buttontext} dragquestions={dragquestions} choiceanswers={choiceanswers} maxperinteraction={maxperinteraction}
         redwords={redwords} typecontent={typecontent} extratime={extratime} dragadd={handleDragAdd} newdragcompletiontext={newdragcompletion} minperinteraction={minperinteraction}
         rangemin={rangemin} rangemax={rangemax} penalty={penalty} timelimit={timelimit} dragremove={handleDragRemove} choiceadd={handleAnswerAdd}/>
      </Row>
    </div>
  )
}

function saveInteraction(props) {
  return (
    <div id="steps4">
      <h5>We are all done, here is a summary of the new {'<interaction>'}:</h5>
      <br/>
      <Row>
        <Col>
            <Card>
              <p>Intro: {introtext}</p>
              <p>Completion: {completiontext}</p>
              <p>Question: {question}</p><br/><br/>
            </Card>
        </Col>
    </Row>
  </div>
  )
}

class CreateInteractionWizardPage extends React.Component<IState, any> {
  public state = {
   activeStep: 0,
   chosenset: '',
   completed: {},
   destination: '',
   difficulty: '1',
   interactionsets: [] as any[],
   // introtext: 'In a few moments a piece of text will appear for 120 seconds. Some words will then disappear. To complete this you will need to fill in the blanks with the missing words! Good luck and trust your memory.',
   interactiontype: '1',
   navigate: false,
   processingmodal: false,
  };

  constructor(props) {
    super(props);
    this.handleSetChange = this.handleSetChange.bind(this);
    this.InteractionSubmit = this.InteractionSubmit.bind(this);
    this.handleGenCreatedItemLoaded = this.handleGenCreatedItemLoaded.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleDifficultyChange = this.handleDifficultyChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

  }

  public totalSteps = () => {
   return getSteps().length;
  };

  public handleTypeChange(event) {
    this.setState({interactiontype: event.target.value})
  }

  public handleSetChange(event) {
    this.setState({chosenset: event.target.value});
    console.log(event.target.value);
  }

  public handleDifficultyChange(event) {
    this.setState({difficulty: event.target.value});
    console.log(event.target.value);
  }

  public handleGenCreatedItemLoaded(res) {
    console.log(res)

    this.setState({processingmodal: false});

    if(res.code ===200){
      console.log('success');
      this.setState({destination: currentBaseUrl() + 'home'})
      this.setState({navigate: true})
    }
    else {
      console.log('err')
    }
  }

  public InteractionSubmit (){

    this.setState({processingmodal: true});

    const item = {
        difficulty_level: this.state.difficulty,
        category: 2,
        completion_text: completiontext,
        interaction_set_id: this.state.chosenset,
        intro_text: introtext,
        min_per_interaction: minperinteraction,
        max_per_interaction: maxperinteraction,
        name: typecontent,
        pq_range_min: rangemin,
        pq_range_max: rangemax,
        time_limit: timelimit,
        extra_time_required: extratime,
        penalty
    } as any

    let endpoint = '';

    if (this.state.interactiontype === '1') {
        endpoint = 'recall';

        const tempwords = [] as any[];

        for (const redword of redwords.split(',')) {
          tempwords.push({word: redword, index: question.indexOf(redword)})
        }

        item.recall_words = tempwords
        item.paragraph_copy = question
    }

    else if (this.state.interactiontype === '2') {
      endpoint = 'drag-and-drop';

      const tempoptions = [] as any[];

      for (const dragquestion of dragquestions)  {
        tempoptions.push({question: dragquestion.drag, answer: dragquestion.drop, completion_text: dragquestion.completion})
      }

      item.options = tempoptions

    }

    else if (this.state.interactiontype === '3') {
      endpoint = 'choice';

      const tempoptions = [] as any[];

      for (const choiceanswer of choiceanswers)  {
        tempoptions.push({answer_text: choiceanswer.answer_text, is_correct_answer: choiceanswer.is_correct_answer})
      }

      item.choice_answers = tempoptions
      item.question_text = question

    }

    else if (this.state.interactiontype === '4') {
      endpoint = 'choice';

      const tempoptions = [] as any[];

      for (const choiceanswer of choiceanswers)  {
        tempoptions.push({answer_text: choiceanswer.answer_text, is_correct_answer: choiceanswer.is_correct_answer})
      }

      item.choice_answers = tempoptions
      item.question_text = question

    }

    createItemJson( 'interactions/interaction-builder/' + endpoint + '/', item, text => this.handleGenCreatedItemLoaded(text));
  }

  public handleNext = () => {
   let activeStep;

   if (this.isLastStep() && !this.allStepsCompleted()) {
     // It's the last step, but not all steps have been completed,
     // find the first step that has been completed
     const steps = getSteps();
     activeStep = steps.findIndex((step, i) => !(i in this.state.completed));
   } else {
     activeStep = this.state.activeStep + 1;
   }
   this.setState({
     activeStep,
   });
  };

  public componentDidMount() {
    console.log("component mounted");
    getGeneralSmartTableData( 'admin/interaction_sets/list_items/', text => this.handleInteractionSetsLoaded('interaction_sets',text));
  }

  public handleInteractionSetsLoaded(objkey, res) {
    if(res.code ===200){
        this.setState({interactionsets: res.response[objkey]});
    }
  }

  public handleBack = () => {
   this.setState(state => ({
     activeStep: state.activeStep - 1,
   }));
  };

  public handleCancel = () => {
    console.log('cancel')
    this.setState({destination: currentBaseUrl() + 'home'})
    this.setState({navigate: true})
   };

  public handleStep = step => () => {
   this.setState({
     activeStep: step,
   });
  };

  public handleComplete = () => {
   const { completed } = this.state;
   completed[this.state.activeStep] = true;
   this.setState({
     completed,
   });
   this.handleNext();
  };

  public handleReset = () => {
   this.setState({
     activeStep: 0,
     completed: {},
   });
  };

  public completedSteps() {
   return Object.keys(this.state.completed).length;
  }

  public isLastStep() {
   return this.state.activeStep === this.totalSteps() - 1;
  }

  public allStepsCompleted() {
   return this.completedSteps() === this.totalSteps();
  }

  public finishSave () {
    const idkey = 'id';
    const titlekey = 'Title';

    if (this.completedSteps() === this.totalSteps()) {
      return (
        <div>
            <Label for="sel">Interaction Set</Label><br/>
            <Select id="sel" value={this.state.chosenset} onChange={this.handleSetChange}  style={{width: '155px', backgroundColor: 'white', color: 'black'}}>
              {this.state.interactionsets.map(d => <MenuItem key={d[idkey]} value={d[idkey]}> {d[titlekey]}</MenuItem>)}
            </Select><br/><br/>

            <Label>Difficulty Level</Label><br/>
            <Select id="sel" value={this.state.difficulty} onChange={this.handleDifficultyChange}  style={{width: '155px', backgroundColor: 'white', color: 'black'}}>
              <MenuItem value={'1'} >Easy</MenuItem>
              <MenuItem value={'2'} >Mild</MenuItem>
              <MenuItem value={'3'} >Hard</MenuItem>
              <MenuItem value={'4'} >Very Hard</MenuItem>
              <MenuItem value={'5'} >Genius</MenuItem>
            </Select><br/><br/>

            <Loader color="#3EE9F7" loaded={!this.state.processingmodal} />

             <Button color="primary" onClick={this.InteractionSubmit}>Save Interaction</Button>
        </div>
      );
    }
    else {
      return (
        <p/>
      );
    }

  }

  public render() {
    if (this.state.navigate === true) {
      return <Redirect to={this.state.destination}/>
    }
    const { classes } = this.props;
    const steps = getSteps();
    const { activeStep } = this.state;

    const idkey = 'id';
    const titlekey = 'Title';

    const wizardStyles = {
      dashBody: {
        height: 'auto',
        marginTop: '1%',
        width: 1080,
      },

      wrapper: {
        display: 'flex',
        justifyContent: 'center'
      }

    }
    return (
      <div>
        <div id="container">
          {/* <div style={wizardStyles.wrapper}> */}
          {/* <div className={classes.root}> */}
            <h4 className="page-title">Create interactions wizard</h4>
        <div>
        <Stepper nonLinear={true} activeStep={activeStep}>
        {steps.map((label, index) => {
           return (
             <Step key={label}>
               <StepButton
                 onClick={this.handleStep(index)}
                 completed={this.state.completed[index]}
               >
                 {label}
               </StepButton>
             </Step>
           );
         })}
       </Stepper>
        </div>

       <div>
         {this.allStepsCompleted() ? (
           <div>
             <Typography className={classes.instructions}>
               All steps completed - you&apos;re finished
             </Typography>
             {this.finishSave()}<br/><br/>

             <button className="red-button reset-interaction-button" onClick={this.handleReset}>Reset</button>
           </div>
         ) : (
           <div className="interaction-type-container">
             {/* <Typography className={`p-interaction-container ${classes.instructions}`}>{getStepContent(activeStep)}</Typography> */}
             <div className={`p-interaction-container ${classes.instructions}`}>{getStepContent(activeStep, this)}
             </div>
             <div className="creation-wizard-buttons">
             <button
                 onClick={this.handleCancel}
                 className={`blue-button ${classes.button} back-interaction-button`}
               >
                 Cancel
               </button>

               <button
                 disabled={activeStep === 0}
                 onClick={this.handleBack}
                 className={`blue-button ${classes.button} back-interaction-button`}
               >
                 Back
               </button>
               <button
                 onClick={this.handleNext}
                 className={`blue-button ${classes.button} next-interaction-button`}
               >
                 Next
               </button>
               {activeStep !== steps.length &&
                 (this.state.completed[this.state.activeStep] ? (
                   <Typography variant="caption" className={classes.completed}>
                     Step {activeStep + 1} already completed
                   </Typography>
                 ) : (
                   <button className="blue-button finish-interaction-button"  onClick={this.handleComplete}>
                     {this.completedSteps() === this.totalSteps() - 1 ? 'Finish' : 'Complete Step'}
                   </button>
                 ))}
             </div>
           </div>
         )}
       </div>
          </div>
      </div>
    );
  }
}


export default withStyles(styles)(CreateInteractionWizardPage);



// WEBPACK FOOTER //
// ./src/pages/CreateInteractionWizard/CreateInteractionWizardPage.Component.tsx